import { useRolesQuery, UseRolesQueryParams } from "../queries/useRolesQuery";
import { IPagination } from "../../../interfaces/IPagination";
import { RoleInterface } from "../../../interfaces/roleInterface";

type Response = {
  roles: RoleInterface[];
  paginationData?: IPagination;
  isLoading: boolean;
};

export const useRoles = (opt: UseRolesQueryParams): Response => {
  const { data, isLoading } = useRolesQuery(opt);
  return {
    roles: data?.data?.roles || [],
    paginationData: data?.data?.pagination,
    isLoading,
  };
};
